export default __webpack_public_path__ + "static/media/wx_code_01.8e9a0437.png";